import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IStratosCardLinkProps } from "./StratosCardLink.props";

export const StratosCardLink = ({ children, className, link }: IStratosCardLinkProps) => {
  const classes = cn(
    "group block border-t border-horizon-blue bg-transparent transition-[background-color,border-color,transform,box-shadow] duration-300 ease-out",
    link &&
      "hover:-translate-y-1 hover:border-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
    className,
  );

  if (!link) return <article className={classes}>{children}</article>;

  const Link = getComponent("Link");
  return (
    <Link
      aria-label={link.accessibilityLabel || undefined}
      className={classes}
      href={link.href}
      rel={link.openInNewTab ? "noopener noreferrer" : undefined}
      target={link.openInNewTab ? "_blank" : undefined}
    >
      {children}
    </Link>
  );
};

StratosCardLink.displayName = "Content::StratosCardLink";
